import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  getCoreDomain,
  CORE_API_ENTRYPOINT,
  customHeadersLD,
} from '@probatix/common/services/services.helpers'
import {
  IUserObservationsResponseHydra,
} from './userObservationsApiService.model'

export const userObservationsApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    getUserObservationTotal: builder.query<IUserObservationsResponseHydra, any>({
      query: () => ({
        headers: customHeadersLD(),
        method: 'GET',
        url: `${CORE_API_ENTRYPOINT}/api/v0/comparable_observations`,
      }),
      transformResponse: (responseData: any) => {
        if (responseData) {
          return {
            "members": responseData?.['member'],
            "totalItems": responseData?.totalItems,
          }
        }

        return { "members": [], "totalItems": 0 }
      },
    }),
  }),
  reducerPath: 'userObservationsApi',
})

export const useGetUserObservationsTotal = userObservationsApi.endpoints.getUserObservationTotal.useLazyQuery
